import React from "react";
import Skills from "./Skills.js";
import Tilt from "react-parallax-tilt";
import Lottie from "lottie-react";
import Coder from "../LottieFiles/coder.json";

const About = () => {
  return (
    <>
      <div className="AboutPage">
        <div className="AboutText">
          <h1 className="AboutTextHeading">
            Get to <b>know</b> me!
          </h1>
          <p>
            Hi, my name is <b>Nguyen Dang Trung</b> and I am from Vietnam. I'm a{" "}
            <b>Frontend developer</b> and a final-year college student pursuing
            a <b>Hanoi University of Mining and Geology </b> in{" "}
            <b>Software Technology</b>. <br />
            <br />I started my journey with an internship as a{" "}
            <b>software developer</b> at <b>Tập đoàn Nhà Phố Việt Nam</b>. After
            that, I gained over a year of professional experience working at{" "}
            <b>Joombooking</b>, where I contributed to real-world projects and
            grew as a fullstack developer. <br />
            <br />I love creating original projects with clean and user-friendly
            designs. You can check out some of my work in the projects section.{" "}
            <br />
            <br />I am <b>open</b> to new collaborations or work where I can
            contribute and grow. Feel free to connect with me — links are in the
            footer.
          </p>
        </div>

        <div>
          <Tilt>
            <Lottie
              className="illustration"
              animationData={Coder}
              loop={true}
            />
          </Tilt>
        </div>
      </div>

      <h1 className="SkillsHeading">Professional Skillset</h1>
      <div className="skills">
        <Skills skill="React" />
        <Skills skill="Next" />
        <Skills skill="Nest" />
        <Skills skill="Node" />
        <Skills skill="Express" />
        <Skills skill="MongoDb" />
        <Skills skill="Postgre" />
        <Skills skill="Github" />
        <Skills skill="Typescript" />
        <Skills skill="Javascript" />
        <Skills skill="HTML" />
        <Skills skill="CSS" />
        <Skills skill="Sass" />
        <Skills skill="Figma" />
        <Skills skill="Bootstrap" />
        <Skills skill="Python" />
        <Skills skill="GraphQL" />
        <Skills skill="Vitest" />
        <Skills skill="MySQL" />
        <Skills skill="Tailwind" />
      </div>
    </>
  );
};

export default About;
